import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, Button, Avatar, Chip, CircularProgress, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// Logo is now imported from public folder instead of using an icon
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
// Emergency Reset functionality is preserved in code but button is removed
// import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SavedFilters from './SavedFilters';
import { useAuth } from '../context/AuthContext';

/**
 * AppHeader component - displays the application header with logo, title, and user authentication status
 */
const AppHeader = ({ onReset }) => {
  // Get authentication state from context
  const { user, loading, isAuthenticated, signOut } = useAuth();
  const [savedFiltersOpen, setSavedFiltersOpen] = useState(false);
  
  // User data display helpers
  
  // Format user display name
  const getUserDisplayName = () => {
    if (!user) return 'User';
    return user.user_metadata?.full_name || 
           user.user_metadata?.name || 
           user.email?.split('@')[0] || 
           'User';
  };
  
  // Get user avatar URL
  const getUserAvatar = () => {
    return user?.user_metadata?.avatar_url || 
           user?.user_metadata?.picture || 
           null;
  };
  
  return (
    <AppBar position="static" elevation={0} sx={{ 
      bgcolor: 'background.default', 
      borderBottom: 'none'
    }}>
      <Toolbar>
        {/* Removed wyspurAI branding from header since it's now in the sidebar */}
        <Box sx={{ flexGrow: 0 }} />
        
        <Box sx={{ flexGrow: 1 }} />
        
        {/* Saved Filters button (always accessible) */}
        <Tooltip title="Manage your saved filters">
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<BookmarkIcon />}
            onClick={() => setSavedFiltersOpen(true)}
            sx={{ mr: 1, borderRadius: '4px', textTransform: 'none' }}
          >
            Saved Filters
          </Button>
        </Tooltip>
        
        {/* Saved Filters Dialog */}
        <Dialog
          open={savedFiltersOpen}
          onClose={() => setSavedFiltersOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Manage Saved Filters</DialogTitle>
          <DialogContent>
            <SavedFilters />
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setSavedFiltersOpen(false)} 
              variant="contained" 
              color="primary"
              sx={{ textTransform: 'none', borderRadius: '4px' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        
        {/* Emergency Reset button removed for clean implementation */}
        
        {/* Authentication section */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {loading ? (
            <CircularProgress size={24} color="primary" />
          ) : isAuthenticated ? (
            <>
              <Chip
                avatar={
                  getUserAvatar() 
                    ? <Avatar src={getUserAvatar()} alt={getUserDisplayName()} /> 
                    : <AccountCircleIcon />
                }
                label={getUserDisplayName()}
                variant="outlined"
                color="primary"
              />
              <Button
                variant="outlined"
                size="small"
                color="primary"
                startIcon={<LogoutIcon />}
                onClick={signOut}
              >
                Logout
              </Button>
            </>
          ) : null}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
